import React from 'react';
import { useTranslation } from 'react-i18next';
import { Text } from 'shared/components/Text/Text';
import AutopaySuccessIcon from '../../../../shared/components/icons/AutopaySuccessIcon';
import { AutopayBaseContainer } from './AutopayModal.styles';
import { Button } from '../../../../shared/components/Button/Button';

export type AutopaySuccessModalProps = {
  isAlreadyEnrolled?: boolean;
  onCompleteFormModal: () => void;
};

export function AutopaySuccessModal({
  isAlreadyEnrolled,
  onCompleteFormModal,
}: AutopaySuccessModalProps) {
  const { t } = useTranslation('translation', { keyPrefix: 'autopayModal' });
  return (
    <AutopayBaseContainer>
      <AutopaySuccessIcon />
      <Text as="h2" $textAlign="center">
        {t(isAlreadyEnrolled ? 'alreadyEnrolledHeader' : 'successHeader')}
      </Text>
      <Text as="p">{t(isAlreadyEnrolled ? 'alreadyEnrolledBody' : 'successBody1')}</Text>
      {!isAlreadyEnrolled && <Text as="p">{t('successBody2')}</Text>}
      <Button margin="36px 0 0 auto" label={t('gotItButton')} onClick={onCompleteFormModal} />
    </AutopayBaseContainer>
  );
}

export default AutopaySuccessModal;
